import { create } from "zustand"
import {
  RackConfiguration,
  RackType,
  ColumnType,
  ArmType,
  ColumnCoating,
  ArmCoating,
} from "./types"

interface CantileverState {
  config: RackConfiguration

  setRackType: (v: RackType) => void
  setColumnType: (v: ColumnType) => void
  setArmType: (v: ArmType) => void
  setColumnHeight: (v: number) => void
  setArmLength: (v: number) => void
  setNumberOfArmLevels: (v: number) => void
  setNumberOfBays: (v: number) => void
  setClearanceTopLevel: (v: number) => void
  setBayWidth: (v: number) => void
  setColumnCoating: (v: ColumnCoating) => void
  setArmCoating: (v: ArmCoating) => void
  setConfig: (config: RackConfiguration) => void

  showAxisHelper: boolean
  toggleAxisHelper: () => void
  showShadows: boolean
  toggleShadows: () => void
  showFloor: boolean
  toggleFloor: () => void
  gradientBackground: boolean
  toggleGradientBackground: () => void
  showDimensions: boolean
  toggleDimensions: () => void

  showBOMDialog: boolean
  setShowBOMDialog: (v: boolean) => void
  showOrderDialog: boolean
  setShowOrderDialog: (v: boolean) => void
}

const defaultConfig: RackConfiguration = {
  rackType: "single",
  columnType: "IPE200",
  armType: "IPE120",
  columnHeight: 5000,
  armLength: 1200,
  numberOfArmLevels: 4,
  numberOfBays: 3,
  clearanceTopLevel: 200,
  bayWidth: 2000,
  columnCoating: "RAL 5019 Blue",
  armCoating: "RAL2008 Orange",
}

export const useCantileverStore = create<CantileverState>((set) => ({
  config: defaultConfig,

  setRackType: (v) => set((s) => ({ config: { ...s.config, rackType: v } })),
  setColumnType: (v) => set((s) => ({ config: { ...s.config, columnType: v } })),
  setArmType: (v) => set((s) => ({ config: { ...s.config, armType: v } })),
  setColumnHeight: (v) => set((s) => ({ config: { ...s.config, columnHeight: v } })),
  setArmLength: (v) => set((s) => ({ config: { ...s.config, armLength: v } })),
  setNumberOfArmLevels: (v) => set((s) => ({ config: { ...s.config, numberOfArmLevels: v } })),
  setNumberOfBays: (v) => set((s) => ({ config: { ...s.config, numberOfBays: v } })),
  setClearanceTopLevel: (v) => set((s) => ({ config: { ...s.config, clearanceTopLevel: v } })),
  setBayWidth: (v) => set((s) => ({ config: { ...s.config, bayWidth: v } })),
  setColumnCoating: (v) => set((s) => ({ config: { ...s.config, columnCoating: v } })),
  setArmCoating: (v) => set((s) => ({ config: { ...s.config, armCoating: v } })),
  setConfig: (config) => set({ config }),

  showAxisHelper: false,
  toggleAxisHelper: () => set((s) => ({ showAxisHelper: !s.showAxisHelper })),
  showShadows: false,
  toggleShadows: () => set((s) => ({ showShadows: !s.showShadows })),
  showFloor: false,
  toggleFloor: () => set((s) => ({ showFloor: !s.showFloor })),
  gradientBackground: true,
  toggleGradientBackground: () => set((s) => ({ gradientBackground: !s.gradientBackground })),
  showDimensions: false,
  toggleDimensions: () => set((s) => ({ showDimensions: !s.showDimensions })),

  showBOMDialog: false,
  setShowBOMDialog: (v) => set({ showBOMDialog: v }),
  showOrderDialog: false,
  setShowOrderDialog: (v) => set({ showOrderDialog: v }),
}))
